import React from "react";
import { FaSave, FaSpinner } from "react-icons/fa";
import { FiChevronDown, FiUser } from "react-icons/fi";

const AttendanceTable = ({
  records,
  handleChange,
  handleStatusChange,
  saveAttendance,
  isSaving,
  dirtySet,
  calcWorkedMinutes,
  minutesToHHMM,
  minsToDecimalHours,
  standardMinutes,
  onOpenDetails,
}) => {
  return (
    <div className="attendance-table-card">
      <div className="table-wrapper">
        <table className="attendance-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>In</th>
              <th>Out</th>
              <th>Lunch In</th>
              <th>Lunch Out</th>
              <th>Worked</th>
              <th>Diff</th>
              <th>Status</th>
              <th>Day Type</th>
              <th>Remarks</th>
              <th className="actions-col">Action</th>
            </tr>
          </thead>
          <tbody>
            {records.map((r) => {
              const wobj = calcWorkedMinutes(r.in_time, r.out_time, r.lunch_in, r.lunch_out);
              const worked = wobj ? wobj.minutes : null;
              const diff = worked != null ? worked - standardMinutes : null;
              return (
                <tr
                  key={r.employee_id}
                  className={`table-row ${dirtySet.has(r.employee_id) ? "dirty-row" : ""} ${
                    isSaving(r.employee_id) ? "saving-row" : ""
                  }`}
                >
                  <td>
                    <div className="employee-cell">
                      <div className="employee-name">
                        <FiUser size={16} strokeWidth={2} />
                        <span>{r.employee_name}</span>
                      </div>
                      <div className="employee-id">ID: {r.employee_id}</div>
                    </div>
                  </td>
                  <td>
                    <input
                      type="time"
                      value={r.in_time || ""}
                      onChange={(e) => handleChange(r.employee_id, "in_time", e.target.value)}
                      className="time-input"
                    />
                  </td>
                  <td>
                    <input
                      type="time"
                      value={r.out_time || ""}
                      onChange={(e) => handleChange(r.employee_id, "out_time", e.target.value)}
                      className="time-input"
                    />
                  </td>
                  <td>
                    <input
                      type="time"
                      value={r.lunch_in || ""}
                      onChange={(e) => handleChange(r.employee_id, "lunch_in", e.target.value)}
                      className="time-input"
                    />
                  </td>
                  <td>
                    <input
                      type="time"
                      value={r.lunch_out || ""}
                      onChange={(e) => handleChange(r.employee_id, "lunch_out", e.target.value)}
                      className="time-input"
                    />
                  </td>
                  <td>
                    {worked != null ? (
                      <div className="worked-time">
                        <div className="worked-primary">{minutesToHHMM(worked)}</div>
                        <div className={`worked-secondary ${diff >= 0 ? "extra" : "short"}`}>
                          {minsToDecimalHours(worked).toFixed(2)} hrs
                        </div>
                      </div>
                    ) : (
                      <span className="text-muted">—</span>
                    )}
                  </td>
                  <td>
                    {worked != null ? (
                      <span className={`diff-badge ${diff < 0 ? "negative" : "positive"}`}>
                        {(diff > 0 ? "+" : "") + minutesToHHMM(Math.abs(diff || 0))}
                      </span>
                    ) : (
                      <span className="text-muted">—</span>
                    )}
                  </td>
                  <td>
                    <select
                      value={r.status || ""}
                      onChange={(e) => handleStatusChange(r.employee_id, e.target.value)}
                      className="status-select"
                    >
                      <option value="">--</option>
                      <option value="Present">Present</option>
                      <option value="Absent">Absent</option>
                      <option value="Half Day">Half Day</option>
                      <option value="Paid Leave">Paid Leave</option>
                      <option value="Unpaid Leave">Unpaid Leave</option>
                      <option value="Holiday">Holiday</option>
                    </select>
                  </td>
                  <td>{r.day_type || <span className="text-muted">—</span>}</td>
                  <td>
                    <input
                      type="text"
                      value={r.remarks || ""}
                      onChange={(e) => handleChange(r.employee_id, "remarks", e.target.value)}
                      placeholder="remarks"
                      className="remarks-input"
                    />
                  </td>
                  <td className="actions-col">
                    <div className="action-buttons-cell">
                      <button
                        className="btn btn-save"
                        onClick={() => saveAttendance(r.employee_id)}
                        disabled={!dirtySet.has(r.employee_id) || isSaving(r.employee_id)}
                      >
                        {isSaving(r.employee_id) ? (
                          <>
                            <FaSpinner className="small-spinner" /> Saving
                          </>
                        ) : (
                          <>
                            <FaSave /> Save
                          </>
                        )}
                      </button>
                      <button className="btn btn-details" onClick={() => onOpenDetails(r.employee_id)}>
                        <FiChevronDown />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceTable;
